// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/shippers",
    element: lazy(() => import("../pages/Shipper")),
  },
  {
    path: "/shippers/editShipper/:shipperId",
    element: lazy(() => import("../pages/Shipper/editShipper")),
  },
];

export default routes;
